<template>

    <ModelForm :client_id="client_id" :item="model" @save="goToModel" @edit="goToModel"/>
</template>

<script>
import ModelForm from '@/components/forms/ModelForm.vue';

export default {
    name: 'ModelCreate',
    components: {
        ModelForm
    },
    props: {
        client_id: {
            type: [String, Number],
            required: true,
        },
        id: {
            type: [String, Number],
            required: false,
        }
    },
    data() {
        return {
            client: {},
            model: {}
        };
    },
    watch: {
        client_id: {
            immediate: true,
            handler() {
                this.getClient();
            }
        },
        id: {
            immediate: true,
            handler() {
                this.getModel();
            }
        }
    },
    methods: {
        goToModel(model) {
            this.$router.push({ name: 'models.view', params: { id: model.id } });
        },
        getClient() {
            return this.$api.get(`/clients/${this.client_id}`)
                .then(response => {
                    this.client = response.data.data;
                });
        },
        getModel(){
            if(this.id){
                this.$api.get(`/styles/${this.id}`)
                .then(response => {
                    this.model = response.data.data;
                });
            }
        }
    },
}

</script>